export const SERVICE_LIST_JOBS = 'SERVICE_LIST_JOBS';
export const SERVICE_LIST_LOGS = 'SERVICE_LIST_LOGS';
export const SERVICE_CLEAR_LOGS = 'SERVICE_CLEAR_LOGS';